/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {brandTokenByCashTag} from '../api'

export const useMutationBrandTokenByCashTag = createReactQueryMutationHook('brandTokenByCashTag', brandTokenByCashTag)
